import { Box, FormControl, Grid, InputLabel, OutlinedInput, styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";

const Cell = styled(TableCell)({
    padding: '10px',
    fontWeight: 'bold',
});

const DisplaySelection = ({
    displayArr,
    setDisplayArr
}) => {
    return (
        <Grid item xs={12} sm={12} md={12} lg={12} style={{ padding: '10px' }}>
            <Typography style={{ fontWeight: 'bold' }}>Selection</Typography>
            <Box sx={{ width: '100%', overflowX: 'auto', border: '1px solid lightgrey', marginTop: 1 }}>
                <TableContainer>
                    <Table sx={{ minWidth: 650 }} aria-label="responsive table">
                        <TableHead>
                            <TableRow>
                                <Cell>Department Name</Cell>
                                <Cell>Project Name</Cell>
                                <Cell>Level Name</Cell>
                                <Cell>Building Name</Cell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {displayArr.map((a) => (
                                <TableRow>
                                    <TableCell>
                                        <FormControl size="small" fullWidth variant="outlined">
                                            <InputLabel htmlFor="standard-adornment-password">Department Name</InputLabel>
                                            <OutlinedInput
                                                label="Department Name"
                                                type='text'
                                                value={a?.department_name || null}
                                                onChange={(e) => {
                                                    setDisplayArr((prevData) => {
                                                        return prevData.map((item) =>
                                                            item.department_id === a.department_id
                                                                ? { ...item, department_name: e.target.value }
                                                                : item
                                                        );
                                                    });
                                                }}
                                            />
                                        </FormControl>
                                    </TableCell>
                                    <TableCell>
                                        {a?.project_name}
                                    </TableCell>
                                    <TableCell>
                                        {a?.level_name}
                                    </TableCell>
                                    <TableCell>
                                        {a?.building_name}
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Grid>
    )
}

export default DisplaySelection;